import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Products } from "@/components/site/Products";
import { Calculator } from "@/components/site/Calculator";
import { Differentials } from "@/components/site/Differentials";
import { About } from "@/components/site/About";
import { QuoteCta } from "@/components/site/QuoteCta";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[#0c0a09]">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <Calculator />
        <Differentials />
        <About />
        <QuoteCta />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#0c0a09", color: "#FAFAF9", border: "1px solid #FACC15" } }} />
    </div>
  );
}

export default App;
